module.exports = __webpack_public_path__ + "img/story2.75049ffd.webp";